<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon" v-b-toggle.filter>
                                <i class="material-icons">search</i>
                            </div>
                            <h4 class="card-title">Filtros</h4>
                        </div>
                        <br />
                        <b-collapse id="filter">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label form="date_by" class="bmd-label-floating">Filtra por data</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="datas"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.date_by"
                                            ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="date" class="bmd-label-floating">Intervalo</label>
                                            <date-picker
                                                range
                                                v-model="form.date"
                                                lang="pt-br"
                                                format="DD/MM/YYYY"
                                                placeholder="Escolha uma data"
                                                :not-after="form.end_at"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.group != ''}"
                                            >
                                            <label form="group" class="bmd-label-floating">Grupo</label>
                                            <input
                                                refs="group"
                                                type="text"
                                                class="form-control"
                                                v-model="form.group"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.quota != ''}"
                                            >
                                            <label form="quota" class="bmd-label-floating">Cota</label>
                                            <input
                                                refs="quota"
                                                type="text"
                                                class="form-control"
                                                v-model="form.quota"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.physical_proposal != ''}"
                                            >
                                            <label form="physical_proposal" class="bmd-label-floating">Contrato</label>
                                            <input
                                                refs="physical_proposal"
                                                type="text"
                                                class="form-control"
                                                v-model="form.physical_proposal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.client != ''}"
                                            >
                                            <label form="client" class="bmd-label-floating">Cliente</label>
                                            <input
                                                refs="client"
                                                type="text"
                                                class="form-control"
                                                v-model="form.client"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label form="representative" class="bmd-label-floating">Representante</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="representative"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.representative"
                                            ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label form="status" class="bmd-label-floating">Status</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="contractStatus"
                                                option-value="id"
                                                option-text="status"
                                                v-model="form.status"
                                            ></model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div
                                            class="form-group bmd-form-group is-filled"
                                            >
                                            <label for="situation" class="bmd-label-floating">Situação</label>
                                            <model-list-select 
                                                class="form-control"
                                                :list="situations"     
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.situation">
                                            </model-list-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group">
                                            <b-form-checkbox id="show_me_all_for_me"
                                                            v-model="form.show_me_all_for_me"
                                                            value="1"
                                                            unchecked-value="0">
                                                Exibir todas as minhas formalizações<br />
                                                <small class="error">Exibir formalizações que foram respondidas e estão com outro usuário</small>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
                            </div>
                        </b-collapse>
                    </div>
                </b-form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th style="cursor: pointer;"
                                            @click="handleChangeOrderBy('contracts.physical_proposal')">
                                            Contrato
                                            <span
                                                v-if="orderBy != 'contracts.physical_proposal'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th width="100px" style="cursor: pointer;"
                                            @click="handleChangeOrderBy('clients.name')">
                                            Cliente
                                            <span
                                                v-if="orderBy != 'clients.name'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th width="30px" style="cursor: pointer;"
                                            @click="handleChangeOrderBy('clients.cpf_cnpj')">
                                            CPF/CNPJ
                                            <span
                                                v-if="orderBy != 'clients.cpf_cnpj'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th>Status</th>
                                        <th>Situação</th>
                                        <th>Pendências</th>
                                        <th style="cursor: pointer;"
                                            @click="handleChangeOrderBy('users.name')">
                                            Representante
                                            <span
                                                v-if="orderBy != 'users.name'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th width="100px" style="cursor: pointer;"
                                            @click="handleChangeOrderBy('contracts.formalized_at')">
                                            D. Cad. Venda
                                            <span
                                                v-if="orderBy != 'contracts.formalized_at'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th width="100px" style="cursor: pointer;"
                                            @click="handleChangeOrderBy('contracts.document_sent_at')">
                                            D. Env. Doc.
                                            <span
                                                v-if="orderBy != 'contracts.document_sent_at'">-</span>
                                            <span v-else>{{ orderDirection == 'asc' ? "↑" : "↓" }}</span>
                                        </th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-show="contracts.length > 0"
                                        v-for="iterator in contracts"
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.physical_proposal }}</td>
                                        <td>{{ iterator.client.name }}</td>
                                        <td>{{ iterator.client.cpf_cnpj }}</td>
                                        <td class="text-center">{{ iterator.contract_status != null ? iterator.contract_status.status : 'Sem status' }}</td>
                                        <td class="text-center">{{ iterator.situation == 'A' ? 'Alocada' : (iterator.situation == 'C' ? 'Cancelada' : 'Não alocada') }}</td>
                                        <td v-if="iterator.pending_reasons.length > 0">
                                            <ol>
                                                <li v-for="reason in iterator.pending_reasons">   
                                                    {{ reason.description }}
                                                </li>
                                            </ol>
                                        </td>
                                        <td class="text-center" v-else>Sem pendência</td>
                                        <td>{{ iterator.representative.name }}</td>
                                        <td class="text-center">{{ iterator.formalized_at | moment('DD/MM/YYYY') }}</td>
                                        <td class="text-center" v-if="iterator.document_sent_at != null">{{ iterator.document_sent_at | moment('DD/MM/YYYY') }}</td>
                                        <td class="text-center" v-else>Documentação não enviada</td>
                                        <td class="td-actions text-right">
                                            <b-button-group>
                                                <router-link
                                                    data-original-title
                                                    title="Histórico da formalização de contrato"
                                                    class="btn btn-outline-primary btn-link"
                                                    tag="button"
                                                    :to="{
                                                        name: 'contracts.history', 
                                                        params: {
                                                            id: iterator.id
                                                        }, 
                                                        query: $route.query
                                                    }"
                                                    >
                                                    <i class="material-icons">find_in_page</i>
                                                </router-link>
                                                <router-link
                                                    data-original-title
                                                    title="Editar Informações e interações da formalização de contrato"
                                                    class="btn btn-block btn-sm btn-outline-primary"
                                                    tag="button"
                                                    :to="{
                                                        name: 'contracts.edit', 
                                                        params: {
                                                            id: iterator.id
                                                        }, 
                                                        query: $route.query
                                                    }"
                                                    >
                                                    <i class="fa fa-thumbs-up" />
                                                </router-link>
                                                <router-link
                                                    data-original-title
                                                    title="Documentos da formalização de contrato"
                                                    class="btn btn-block btn-sm btn-outline-primary"
                                                    tag="button"
                                                    :to="{
                                                        name: 'contracts.documents',
                                                        params: {
                                                            id: iterator.id
                                                        }, 
                                                        query: $route.query
                                                    }"
                                                    >
                                                    <i class="fa fa-file-pdf" />
                                                </router-link>
                                            </b-button-group>
                                        </td>
                                    </tr>
                                    <tr v-show="contracts.length==0">
                                        <td colspan="7">Nenhuma formalização encontrada!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer" v-show="contracts.length">
                        <div class="row" style="width:100%;">
                            <div class="col-sm-4">
                                <model-list-select
                                    class="form-control"
                                    :list="limits"
                                    option-value="limit"
                                    option-text="text"
                                    v-model="limit"
                                    @input="onSubmit($event)"
                                ></model-list-select>
                            </div>
                            <div class="col-sm-4 text-center">
                                <b-pagination
                                order="is-right"
                                v-show="contracts.length > 0"
                                v-model="currentPage"
                                :simple="false"
                                :per-page="limit"
                                :total-rows="total"
                                @change="pageChange"
                                ></b-pagination>
                            </div>
                            <div class="col-sm-4 text-right text-secondary">
                                {{ to }} registros de {{ total }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
        ref="modal"
        dialog-class="modal-lg"
        hide-footer
        scrollable
        :visible="$route.meta.showModal"
        :title="$route.meta.title"
        @hide="hideModal"
        >
        <router-view name="modal" />
        </b-modal>
    </div>
</template>
<script>
    import FiltersSearch from './Filters';
    import Vue from "vue";
    export default {
        components : { FiltersSearch },
        computed: {
            contracts() {
                console.log(this.$store.state.contracts.itens)
                return this.$store.state.contracts.itens.data != undefined ? this.$store.state.contracts.itens.data : [];
            },
            contractStatus() {
                return this.$store.state.contract_status.itens;
            },
            representative() {
                var salesmans = [
                    {
                        id: "",
                        name: "Todos"
                    }
                ];
                return salesmans.concat(this.$store.state.users.salesmans);
            }
        },
        created: function () {
            this.$root.$on("hideModal", () => {
                this.$refs.modal.hide();
            });
            this.$root.$on("updateList", () => {
                this.initQueryString();
            });
            this.initQueryString();
        },
        data() {
            return {
                currentPage: 1,
                datas: [
                    {
                        id: "contracts.formalized_at",
                        name: "Data venda"
                    },
                    {
                        id: "contracts.document_sent_at",
                        name: "Data envio documentação"
                    },
                ],
                form: {
                    client: '',
                    date_by: 'contracts.document_sent_at',
                    representative: 0,
                    end_at: Vue.moment(),
                    date: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    physical_proposal: '',
                    group: '',
                    quota: '',
                    show_me_all_for_me: 0,
                    situation: 'T',
                    status: ''
                },
                limit: 0,
                limits : [
                    { limit : 5, text : 'Exibir 5(cinco) por página' },
                    { limit : 10, text : 'Exibir 10(dez) por página' },
                    { limit : 25, text : 'Exibir 25(vinte e cinco) por página' },
                    { limit : 50, text : 'Exibir 50(cinquenta) por página' },
                ],
                situations: [
                    {
                        id: "A",
                        name: "Alocada"
                    },
                    {
                        id: "C",
                        name: "Cancelada"
                    },
                    {
                        id: "N",
                        name: "Não alocada"
                    },
                    {
                        id: "T",
                        name: "Todas"
                    }
                ],
                orderBy: "contracts.document_sent_at",
                orderDirection: "asc",
                textSearch : '',
                items : [],
                total: 0,
                to : 0
            };
        },
        methods: {
            handleChangeOrderBy(orderBy) {
                if (this.orderBy != orderBy) {
                    this.orderBy = orderBy
                    this.orderDirection = 'asc'
                } else {
                    if (this.orderDirection == 'asc') {
                        this.orderDirection = 'desc'
                    } else {
                        this.orderDirection = 'asc'
                    }
                }

                this._refreshData()
            },
            hideModal() {
                this.$router.go(-1);
            },
            _refreshData() {
                this.getData();
            },
            async getData() {
                var self = this;
                var params = {
                    limit: self.limit,
                    currentPage: self.currentPage,
                    params: self.form,
                    orderBy: self.orderBy,
                    orderDirection: self.orderDirection
                }

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('contracts/all', params);

                response.then(function (_pagination) {
                    self.total = _pagination.total;
                    self.to = _pagination.to;
                    self.$root.$emit('onLoading');
                    self.getDataContractStatus();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getDataContractStatus();
                });
            },
            async getDataContractStatus() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('contract_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });
            },
            async getSalesmans() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('users/getSalesmans', {all_users:true});

                response.then(() => {
                    self.$root.$emit('onLoading');
                });

                response.catch(() => {
                    self.$root.$emit('onLoading');
                });
            },
            initQueryString() {
                var self = this;
                var query = self.$route.query;

                self.limit = 25;

                if (query.limit) {
                    self.limit = parseInt(query.limit);
                }
                if (query.currentPage) {
                    setTimeout(function(){
                        self.pageChange(parseInt(query.currentPage));
                    }, 900);
                }
                if (query.date && query.date.length == 2) {
                    self.form.date = [
                        Vue.moment(query.date[0]),
                        Vue.moment(query.date[1])
                    ];
                }
                if (query.client) {
                    self.form.client = query.client
                }
                if (query.representative) {
                    self.form.representative = query.representative
                }
                if (query.physical_proposal) {
                    self.form.physical_proposal = query.physical_proposal
                }
                if (query.group) {
                    self.form.group = query.group
                }
                if (query.quota) {
                    self.form.quota = query.quota
                }
                if (query.status) {
                    self.form.group = query.status
                }
                if (query.show_me_all_for_me) {
                    self.form.show_me_all_for_me = query.show_me_all_for_me
                }

                self.getData()
            },
            pageChange(_pageNum) {
                var self = this;

                self.currentPage = _pageNum

                self.setQueryString();

                self.getData();
            },
            async onReset() {
                var self = this;
                self.form = {
                    client: '',
                    date_by: 'contracts.document_sent_at',
                    end_at: Vue.moment(),
                    date: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    physical_proposal: '',
                    representative: 0,
                    group: '',
                    quota: '',
                    status: ''
                };
                this._refreshData()
            },
            onSubmit(_ev=null) {
                if(isNaN(_ev))
                    _ev.preventDefault();

                var self = this;

                self.setQueryString();

                self.getData();
            },
            setQueryString() {
                var self = this;

                self.$router.push({
                    name: "contracts.index",
                    query: {
                        limit: self.limit ? self.limit : 5,
                        currentPage: self.currentPage,
                        client: self.form.client,
                        date_by: self.form.date_by,
                        date: [
                            Vue.moment(self.form.date[0]).format('YYYY-MM-DD'),
                            Vue.moment(self.form.date[1]).format('YYYY-MM-DD')
                        ],
                        group: self.form.group,
                        physical_proposal: self.form.physical_proposal,
                        quota: self.form.quota,
                        representative: self.form.representative,
                        status: self.form.status,
                        show_me_all_for_me: self.form.show_me_all_for_me
                    }
                })
            }
        }
    }
</script>